import Vue from 'vue'
import Router from 'vue-router'

// import Index from '@/components/detail/Index.vue'
const Index = () =>import( '@/components/detail/Index')
// const AdList = () =>import( '@/components/admin/ad/AdList')
// import Images from '@/components/detail/Images.vue'
// import Test from '@/components/detail/Test.vue'
// import ArticleChannelPromotion from '@/components/detail/ChannelPromotion.vue'
const ArticleChannelPromotion = () =>import( '@/components/detail/ChannelPromotion')
// import MagList from '@/components/magazine/MagList.vue'
const MagList = () =>import( '@/components/magazine/MagList')
// import ArticleDetail from '@/components/magazine/ArticleDetail.vue'
const ArticleDetail = () =>import( '@/components/magazine/ArticleDetail')
// import MagColumn from '@/components/magazine/MagColumn.vue'
const MagColumn = () =>import('@/components/magazine/MagColumn')
const MagColumnFree = () =>import('@/components/magazine/MagColumnFree')
// import Magazine from '@/components/magazine/Magazine.vue'
const Magazine = () =>import('@/components/magazine/Magazine')
// import Buysuccess from '@/components/magazine/BuySuccess.vue'
const Buysuccess = () =>import('@/components/magazine/BuySuccess')

const MagPaidSubject = () =>import('@/components/magazine/MagPaidSubject')
// import Subsuccess from '@/components/magazine/SubSuccess.vue'
// const Subsuccess = () =>import('@/components/magazine/SubSuccess')
// import InviteBuyList from '@/components/invitebuy/InviteBuyList'
const InviteBuyList = () =>import('@/components/invitebuy/InviteBuyList')
// import Subscription from '@/components/invitebuy/Subscription'
const Subscription = () =>import('@/components/invitebuy/Subscription')
// import QueryOrder from '@/components/invitebuy/QueryOrder'
const QueryOrder = () =>import('@/components/invitebuy/QueryOrder')
//
const AskEditor = () =>import('@/components/askeditor/AskEditor')
//
const SuverQuestionTopic = () =>import('@/components/suverquestiontopic/SuverQuestionTopic')

const Demo = () =>import('@/components/detail/Demo')

const ActivityWeb = () =>import('@/components/activityweb/Index')

import buyGroupRouter from './buyGroupRouter.js'
import orderRouter from './orderRouter.js'
import chunjie2022Router from "./chunjie2022Router";
import activityRouter from "./activityRouter";
import couponRouter from "./couponRouter";
import luckprizeRouter from "./luckprizeRouter";

Vue.use(Router)


export default new Router({
    // mode:'history',
    routes: [
        {
            path: '/',
            component: Index,
            meta: {title: '加载中'}
        },
        {
            path: '/article_channel_promotion',
            component: ArticleChannelPromotion,
            meta: {title: '加载中'}
        },
        {
            path: '/demo',
            component: Demo,
            meta: {title: '加载中'}
        },
        {
            path: '/mags',
            component: MagList,
            meta: {title: '杂志购买'}
        },
        {
            path: '/article',
            component: ArticleDetail,
            meta: {title: 'Vista看天下'}
        },
        {
            path: '/column',
            component: MagColumn,
            meta: {title: '目录'}
        },
        {
            path: '/columnf',
            component: MagColumnFree,
            meta: {title: '目录'}
        },
        {
            path: '/mag/paid_subject',
            component: MagPaidSubject,
            meta: {title: '专栏'}
        },
        {
            path: '/magazine',
            component: Magazine,
            meta: {title: '订阅'}
        },


        {
            path: '/buysuccess',
            component: Buysuccess,
            meta: {title: '购买成功'}
        },
        // {
        //     path: '/subsuccess',
        //     component: Subsuccess,
        //     meta: {title: '订阅成功'}
        // },

        {
            path: '/inviteBuyList',
            component: InviteBuyList,
            meta: {title: 'Vista看天下'}
        },

        {
            path: '/subscription',
            component: Subscription,
            meta: {title: '订阅'}
        },
        {
            path: '/queryOrder',
            component: QueryOrder,
            meta: {title: '查询订单'}
        },
        {
            path: '/askeditor/askeditor',
            component: AskEditor,
            meta: {title: '问编辑'}
        },
        {
            path: '/suverquestiontopic/suverquestiontopic',
            component: SuverQuestionTopic,
            meta: {title: '问题调查'}
        }



    ].concat(buyGroupRouter).concat(orderRouter).concat(chunjie2022Router).concat(activityRouter)
        .concat(couponRouter).concat(luckprizeRouter)
})



// WEBPACK FOOTER //
// ./src/router/index.js